
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IdeaTopCardFooterFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Investment_Idea"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardButtonsFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardFixedFeesFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardPropertiesFragment"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"IdeaTopCardTariffFragment"},"directives":[]}]}}],"loc":{"start":0,"end":386}};
    doc.loc.source = {"body":"#import \"./components/Buttons/fragment.gql\"\n#import \"./components/Properties/fragment.gql\"\n#import \"./components/Fees/FixedFees/fragment.gql\"\n#import \"./components/Fees/Tariff/fragment.gql\"\n\nfragment IdeaTopCardFooterFragment on Investment_Idea {\n  id\n  ...IdeaTopCardButtonsFragment\n  ...IdeaTopCardFixedFeesFragment\n  ...IdeaTopCardPropertiesFragment\n  ...IdeaTopCardTariffFragment\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./components/Buttons/fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./components/Properties/fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./components/Fees/FixedFees/fragment.gql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./components/Fees/Tariff/fragment.gql").definitions));


      module.exports = doc;
    
